/*
 *
 * Selectors for GiftCardLanding
 *
 */

import { createSelector } from 'reselect';
import { utils } from '../../devUtils';

const selectGiftCardLandingDomain = (state) => state.get('GiftCardLanding');

const selectGiftCardLanding = () => createSelector(
  selectGiftCardLandingDomain,
  (GiftCardLanding) => GiftCardLanding,
);

const selectGiftCardLandingData = () => createSelector(
  selectGiftCardLandingDomain,
  (GiftCardLanding) => utils.immutableToJS(GiftCardLanding.get('data')),
);

const selectLyraGiftCard = () => createSelector(
  selectGiftCardLandingDomain,
  (GiftCardLanding) => utils.immutableToJS(GiftCardLanding.get('lyraGiftCardDetails')),
);

export { selectGiftCardLanding, selectGiftCardLandingData, selectLyraGiftCard };



// WEBPACK FOOTER //
// client/containers/GiftCardLanding/selectors.js